import { CourseResourceEnum } from '@/Enums/enum';
import { StyledP } from '@/Shared/Typography/typography';

interface CourseResourcePlaceholderProps {
	isApprovalMode: boolean;
	state: { show: string };
	mediaLength: number;
	textbookLength: number;
}

const CourseResourcePlaceholder = ({
	isApprovalMode,
	state,
	mediaLength,
	textbookLength,
}: CourseResourcePlaceholderProps) => {
	const isType = (type: string, length: number) => state.show === type && length === 0;
	const allResources = mediaLength + textbookLength;

	const renderText = () => {
		if (isApprovalMode) {
			if (isType(CourseResourceEnum.All, allResources))
				return 'No resources have been added to this course.';
			if (isType(CourseResourceEnum.Media, mediaLength))
				return 'No media resources have been added.';
			if (isType(CourseResourceEnum.Textbook, textbookLength))
				return 'No textbook resources have been added.';
			return '';
		}

		if (isType(CourseResourceEnum.All, allResources)) return 'Add the first resource.';
		if (isType(CourseResourceEnum.Media, mediaLength)) return 'Add the first media resource.';
		if (isType(CourseResourceEnum.Textbook, textbookLength))
			return 'Add the first textbook resource.';
		return '';
	};

	const text = renderText();
	return text ? <StyledP mb="32px">{text}</StyledP> : null;
};

export default CourseResourcePlaceholder;
